import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import Budgets from 'src/assets/images/Budgets.png'
import Cards from 'src/assets/images/Cards.png'
import { SupportedBrands } from 'src/enums'
import { selectFixedElementPushdown } from 'src/redux/selectors/css.selectors'
import {
  selectAppName,
  selectBrandName,
} from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface UnauthedPageContainerProps {
  className?: string
  topLeftImage?: React.ReactElement
  bottomLeftImage?: React.ReactElement
  topLeftImageScale?: number
  scrollContainerRef?: React.Ref<HTMLDivElement>
}

const UnauthedPageContainer: React.FC<
  React.PropsWithChildren<UnauthedPageContainerProps>
> = (props) => {
  const appName = useSelector(selectAppName)
  const fixedElementPushdown = useSelector(selectFixedElementPushdown)
  const brandName = useSelector(selectBrandName)
  const showImages = brandName !== SupportedBrands.Jpm
  return (
    <div
      css={css`
        background-color: ${styleConstants.colors.gray_light};
        position: relative;
        display: flex;
        width: 100%;
      `}
      className={props.className}
    >
      <Helmet>
        <title>{`Get started today and create virtual cards with the card in your pocket. | ${appName}`}</title>
        <meta
          name="description"
          content={`Create an ${appName} account to create, send, and manage virtual cards for all your business payments.`}
        />
      </Helmet>
      <div
        css={css`
          width: 100%;
        `}
      >
        {showImages && (
          <div
            css={css`
              position: absolute;
              inset: 0;
              pointer-events: none;
              overflow: hidden;
            `}
          >
            {props.topLeftImage && (
              <div
                css={css`
                  position: absolute;
                  top: ${0 + fixedElementPushdown}px;
                  left: 0px;
                  transform: ${props.topLeftImageScale
                    ? css`scale(calc(${props.topLeftImageScale}));`
                    : css`scale(calc(3/4));`};
                  transform-origin: top left;
                `}
              >
                {props.topLeftImage}
              </div>
            )}
            <img
              src={Cards}
              alt={'Cards'}
              css={css`
                position: absolute;
                top: ${-115 + fixedElementPushdown}px;
                right: -115px;
                transform: scale(calc(0.4));
                transform-origin: top right;
              `}
            />
            {props.bottomLeftImage || (
              <img
                src={Budgets}
                alt={'Budgets'}
                css={css`
                  position: absolute;
                  bottom: -190px;
                  left: -233px;
                  transform: scale(calc(0.5));
                  transform-origin: bottom left;
                `}
              />
            )}
          </div>
        )}
        <div
          ref={props.scrollContainerRef}
          css={css`
            position: relative;
            height: 100vh;
            overflow: auto;
          `}
        >
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default UnauthedPageContainer
